import React, { useState } from 'react';
import { OrbitControls } from '@react-three/drei';

const CameraControls = props => {
  const [camRotate, setCamRotate] = useState(false);
  props.getCamRotationControl(setCamRotate);

  return (
    <OrbitControls
      enableRotate={camRotate}
      enableZoom={false}
      enablePan={false}
    />
  );
};

export default CameraControls;
